import { Axios } from "axios"
import { getEnv } from "../../../../utils/env"
import {
  FeatureFlagBase,
  FeatureFlagName,
  FeatureFlagStatesType,
  FeatureFlag
} from "./types"
import { getCustomHeaders } from "../Headers"

const client = new Axios({
  baseURL: getEnv("CLOUD_FUNCTION_ROOT"),
  headers: getCustomHeaders()
})
client.interceptors.response.use(response => JSON.parse(response.data))

export const FORCED_DISABLED_FEATURE_FLAGS: FeatureFlagStatesType = {
  [FeatureFlagName.read_aloud_highlighting]: false,
  [FeatureFlagName.reporting_average_days_active_data]: false,
  [FeatureFlagName.reporting_configuration_platform_settings_module]: false,
  [FeatureFlagName.reporting_content_library_date_filter]: false,
  [FeatureFlagName.reporting_content_library_reporting_categories]: false,
  [FeatureFlagName.reporting_graphql_performance_questions]: false,
  [FeatureFlagName.reporting_insights_performance_content_mastery_hide_eact]:
    false,
  [FeatureFlagName.reporting_insights_performance_questions_show_all_programs]:
    false,
  [FeatureFlagName.reporting_insights_performance_questions_viewed]: false,
  [FeatureFlagName.reporting_teaching_tools_mastery_curriculum_module]: false,
  [FeatureFlagName.student_experience_insights_completions_module]: false,
  [FeatureFlagName.student_experience_insights_questions_module]: false,
  [FeatureFlagName.use_cube_filters]: false
}

export const applyFeatureFlagOverrides = (
  featureFlags: FeatureFlagStatesType = {}
): FeatureFlagStatesType => ({
  ...featureFlags,
  ...FORCED_DISABLED_FEATURE_FLAGS
})

export const checkFeatureFlag = (
  name: string,
  strategies?: Record<string, string>
) => {
  const strategiesParams = Object.entries(strategies ?? {}).reduce(
    (acc, [key, val]) => ({
      ...acc,
      [`strategies[${key}]`]: val
    }),
    {}
  )

  return client.get<FeatureFlagBase, FeatureFlagBase>(
    "miscGroup-checkFeatureFlag",
    { params: { name, ...strategiesParams } }
  )
}

export const checkFeatureFlags = (strategies?: Record<string, string>) => {
  const strategiesParams = Object.entries(strategies ?? {}).reduce(
    (acc, [key, val]) => ({
      ...acc,
      [`strategies[${key}]`]: val
    }),
    {}
  )

  return client.get<FeatureFlagStatesType, FeatureFlagStatesType>(
    "miscGroup-checkFeatureFlags",
    { params: { ...strategiesParams } }
  )
}

export const getFeatureFlag = name => {
  return client.get<FeatureFlag, FeatureFlag>("miscGroup-getFeatureFlag", {
    params: { name }
  })
}

export const getFeatureFlags = () => {
  return client.get<FeatureFlag[], FeatureFlag[]>("miscGroup-getFeatureFlags")
}
